import { render } from "./TvmMyAddress.vue?vue&type=template&id=1039189d&scoped=true"
import script from "./TvmMyAddress.vue?vue&type=script&lang=js"
export * from "./TvmMyAddress.vue?vue&type=script&lang=js"

import "./TvmMyAddress.vue?vue&type=style&index=0&id=1039189d&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1039189d"]])

export default __exports__